/* eslint-disable security/detect-object-injection */
import './ProductDetailForm.style.less'
import {
  Button,
  Col,
  Form,
  Input,
  notification,
  Radio,
  Row,
  Typography,
} from 'antd'
import { useEffect, useState } from 'react'
import FormItem from '../FormItem/FormItem'
import {
  getOrderQuantityInformDataByColorSize,
  getOrderQuantityInformDataByDestination,
} from '../../EditOrder.helper'
import { getUrlParams, isEmptyValue, numberWithCommas } from '@/utils/common'
import {
  quantity_breakdown_types,
  quantity_breakdown_types_obj,
  quantity_total_only_types,
} from '@/screens/Order/constant/quanity_breakdown'
import { orderBy } from 'lodash'
import Fade from '@/components/Fade'
import { useParams } from 'react-router-dom'
import { COLOR_SIZE_SEPARATOR_KEY } from '@/constant/pbf'

const { Title } = Typography
interface Props {
  fields: any
  defaultField?: any
  setField: (fields) => void
  form: any
  onImport: () => void
  onApplyAttributeSizes?: (sizes) => void
  orderSetting: any
  isSuccessCreated: boolean
  orderItemSetting?: any
}

const { TOTAL_QUANTITY_ONLY } = quantity_breakdown_types_obj

function ProductDetailForm(props: Props) {
  const { defaultField, isSuccessCreated, orderItemSetting = null } = props
  const [attributes, setAttribute] = useState<any>({ size: null, colors: null })
  const [attributeValue, setAttributeValue] = useState(new Map())
  const [total, settotal] = useState(0)

  const customQtyTypes = orderItemSetting
    ? quantity_total_only_types
    : quantity_breakdown_types

  const params = useParams()

  const [isOldOrder] = useState(
    !isEmptyValue(params.id) && isEmptyValue(defaultField?.quantity_breakdown)
      ? true
      : false
  )

  const onApply = (isQuantityBreakdown: boolean) => {
    const values = props.form.getFieldsValue([
      'colors',
      'size',
      'attributeDestination',
      'quantity_breakdown',
    ])

    if (isQuantityBreakdown) {
      if (isEmptyValue(values.quantity_breakdown)) {
        notification.warn({
          placement: 'top',
          message: 'Please select a quantity breakdown',
          duration: 3,
        })
        return
      }
    }

    switch (values.quantity_breakdown) {
      case quantity_breakdown_types_obj.BY_DESTINATION:
        if (isEmptyValue(values.attributeDestination)) {
          notification.warn({
            placement: 'top',
            message: 'destinations are empty',
            duration: 3,
          })
        }
        props.onApplyAttributeSizes(values.size)
        setAttribute(values)
        break
      case quantity_breakdown_types_obj.TOTAL_QUANTITY_ONLY:
        props.onApplyAttributeSizes(values.size)
        setAttribute(values)
        break
      default:
        if (isEmptyValue(values.colors)) {
          notification.warn({
            placement: 'top',
            message: 'Colors are empty',
            duration: 3,
          })
        }
        if (isEmptyValue(values.size)) {
          notification.warn({
            placement: 'top',
            message: 'Size are empty',
            duration: 3,
          })
        }
        props.onApplyAttributeSizes(values.size)
        setAttribute(values)
        break
    }
  }

  const quanityBrType = () => {
    return props.form.getFieldsValue(['quantity_breakdown'])?.quantity_breakdown
  }

  useEffect(() => {
    const initCurrentAttribute = () => {
      const temp = {}
      defaultField?.attributes.forEach((element) => {
        temp[element.key] = element.value
      })
      setAttribute(temp)
    }
    initCurrentAttribute()
    let orderQuantity
    if (!isEmptyValue(defaultField?.quantity_breakdown)) {
      if (
        defaultField.quantity_breakdown?.value ==
        quantity_breakdown_types_obj.BY_DESTINATION
      ) {
        orderQuantity = getOrderQuantityInformDataByDestination(
          defaultField?.order_quantity.value
        )
      } else if (
        defaultField.quantity_breakdown?.value ==
        quantity_breakdown_types_obj.TOTAL_QUANTITY_ONLY
      ) {
        orderQuantity = new Map()
      } else {
        orderQuantity = getOrderQuantityInformDataByColorSize(
          defaultField?.order_quantity.value
        )
      }
    } else if (isOldOrder) {
      orderQuantity = getOrderQuantityInformDataByColorSize(
        defaultField?.order_quantity.value
      )
    }
    setAttributeValue(orderQuantity)
    const values = props.form.getFieldsValue([
      'colors',
      'size',
      'quantity_breakdown',
      'attributeDestination',
    ])
    props.onApplyAttributeSizes(values.size)
    setAttribute(values)
  }, [defaultField, isSuccessCreated])

  const totalByColorSize = () => {
    const values = props.form.getFieldsValue()
    let total = 0
    for (const [key, value] of Object.entries(values) as any) {
      if (key.includes(COLOR_SIZE_SEPARATOR_KEY)) {
        total += value ? Number(value) : 0
      }
    }
    return total ?? 0
  }

  const totalByDestination = () => {
    const values = props.form.getFieldsValue()
    let total = 0
    for (const [key, value] of Object.entries(values) as any) {
      if (key.includes('~destination~')) {
        total += value ? Number(value) : 0
      }
    }
    return total ?? 0
  }

  const typeKey = getUrlParams('type')

  useEffect(() => {
    switch (quanityBrType()) {
      case quantity_breakdown_types_obj.TOTAL_QUANTITY_ONLY:
        settotal(0)
        break
      case quantity_breakdown_types_obj.BY_DESTINATION:
        settotal(totalByDestination())
        break
      default:
        settotal(totalByColorSize())
        break
    }
  }, [attributeValue, attributes])

  const renderSelectQtyBreakdown = () => {
    let initValue = ''

    if (orderItemSetting) {
      initValue = TOTAL_QUANTITY_ONLY
      props.form.setFieldsValue({
        ['quantity_breakdown']: initValue,
      }) // DEFAULT SELECTED FOR CREATE NEW ORDER
    } else {
      if (!isEmptyValue(props.defaultField.quantity_breakdown?.value)) {
        initValue = props.defaultField.quantity_breakdown?.value
      } else if (
        !isEmptyValue(
          props.defaultField?.attributes?.find(
            (item) => item.field === 'colors'
          )?.value
        )
      ) {
        initValue = quantity_breakdown_types_obj.BY_COLOR_AND_SIZE
      }
    }

    return (
      !isEmptyValue(props.defaultField.quantity_breakdown) && (
        <Row align={'middle'} className="qty-breakdown-container">
          <Form form={props.form}>
            <Form.Item
              style={{ marginBottom: 0 }}
              label="Quantity Breakdown"
              name="quantity_breakdown"
              initialValue={initValue}
            >
              <Radio.Group size="large">
                {customQtyTypes.map((item) => {
                  return (
                    <Radio
                      className="radio-button-label"
                      key={item.label}
                      value={item.value}
                    >
                      {item?.label}
                    </Radio>
                  )
                })}
              </Radio.Group>
            </Form.Item>
          </Form>
          <Button
            className="button-apply"
            onClick={() => onApply(true)}
            type="primary"
            size="large"
          >
            Apply
          </Button>
        </Row>
      )
    )
  }

  return (
    <Fade>
      <div className="pbf-product-detail-form">
        <Title level={3}>Information</Title>
        <Form name="information" requiredMark={true} form={props.form}>
          <div className="row-container">
            {orderBy(
              props.defaultField?.information,
              ['display_order'],
              ['asc']
            ).map((item, index) => {
              return (
                <FormItem
                  orderSetting={props.orderSetting}
                  key={index}
                  item={item}
                />
              )
            })}
          </div>
        </Form>

        <div style={{ marginTop: 20 }} />
        <Title level={3}>Attributes</Title>
        <Form name="attribute" form={props.form}>
          <Row justify="end">
            {orderBy(
              props.defaultField?.attributes,
              ['display_order'],
              ['asc']
            ).map((item, index) => {
              return (
                <Col key={index} span={24}>
                  <FormItem orderSetting={props.orderSetting} item={item} />
                </Col>
              )
            })}
          </Row>
          <Row justify={'end'}>
            {isEmptyValue(props.defaultField.quantity_breakdown) && (
              <Button
                // className="button-apply"
                onClick={() => onApply(false)}
                type="primary"
                size="large"
              >
                Apply
              </Button>
            )}
          </Row>
        </Form>
        <Title level={3}>Order Quantity</Title>

        {renderSelectQtyBreakdown()}

        {(!isEmptyValue(
          props.form.getFieldsValue(['quantity_breakdown'])?.quantity_breakdown
        ) ||
          isOldOrder ||
          typeKey == 'clone') &&
          (quanityBrType() ==
          quantity_breakdown_types_obj.TOTAL_QUANTITY_ONLY ? (
            <Form
              className="destination-container"
              name="order_quantity"
              form={props.form}
            >
              <Row className="destination-row" align={'middle'}>
                <div className="destination-name-container">
                  <p className="destination-name">Total Quantity</p>
                </div>
                <div className="destination-input-container">
                  <Form.Item
                    initialValue={
                      typeof props.defaultField?.order_quantity?.value ==
                      'object'
                        ? ''
                        : props.defaultField?.order_quantity?.value
                    }
                    name={'orderQuantity'}
                    required
                    rules={[
                      {
                        required: true,
                        message: '',
                      },
                    ]}
                  >
                    <Input
                      placeholder={'0'}
                      size="large"
                      onKeyDown={(e) => {
                        if (e.code === 'Minus') {
                          e.preventDefault()
                        }
                      }}
                      className="input"
                      type="number"
                      min="0"
                      onWheel={(e: any) => e.target.blur()}
                      defaultValue={
                        typeof props.defaultField?.order_quantity?.value ==
                        'object'
                          ? ''
                          : props.defaultField?.order_quantity?.value
                      }
                    />
                  </Form.Item>
                </div>
              </Row>
            </Form>
          ) : quanityBrType() == quantity_breakdown_types_obj.BY_DESTINATION ? (
            !isEmptyValue(attributes.attributeDestination) && (
              <>
                <Form
                  className="destination-container"
                  name="order_quantity"
                  form={props.form}
                >
                  {attributes.attributeDestination.map((destination) => (
                    <Row
                      key={destination}
                      className="destination-row"
                      align={'middle'}
                    >
                      <div className="destination-name-container">
                        <p className="destination-name">{destination}</p>
                      </div>
                      <div className="destination-input-container">
                        <Form.Item
                          initialValue={attributeValue?.get(destination)}
                          name={destination + '~destination~'}
                          rules={[
                            {
                              required: true,
                              message: '',
                            },
                          ]}
                        >
                          <Input
                            placeholder={'0'}
                            size="large"
                            onKeyDown={(e) => {
                              if (e.code === 'Minus') {
                                e.preventDefault()
                              }
                            }}
                            className="input"
                            type="number"
                            onWheel={(e: any) => e.target.blur()}
                            min="0"
                            defaultValue={attributeValue?.get(destination)}
                            onChange={({ target }) => {
                              const temp = new Map(attributeValue)
                              temp.set(destination, target.value)
                              setAttributeValue(temp)
                            }}
                          />
                        </Form.Item>
                      </div>
                    </Row>
                  ))}
                </Form>
                <Title
                  style={{ width: '100%' }}
                  className="total-order"
                  level={5}
                >
                  Total Order
                  Quantity:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {numberWithCommas(totalByDestination())}
                </Title>
              </>
            )
          ) : (
            !isEmptyValue(attributes.colors) &&
            !isEmptyValue(attributes.size) && (
              <Form name="order_quantity" form={props.form}>
                <Row className="quantity-wrapper" justify="end">
                  <Col className="left-quantity-wrapper" span={2}>
                    <div className="left-quantity-header" />
                    {attributes.colors.map((color) => (
                      <div className="left-quantity-header" key={color}>
                        <span>{color}</span>
                      </div>
                    ))}
                  </Col>
                  {/*  */}
                  <Col span={22} className="scrollable-container">
                    <Row className="row-container-qty">
                      {attributes.size.map((size, indexSize) => (
                        <Col
                          className={
                            indexSize === attributes.size.length - 1 &&
                            'right-quantity-wrapper'
                          }
                          key={size}
                          span={2}
                        >
                          <Row className="top-quantity-header">
                            <span>{size}</span>
                          </Row>
                          {attributes.colors.map((color, index) => (
                            <Row
                              className={
                                index % 2
                                  ? 'input-wrapper input-wrapper-gray'
                                  : 'input-wrapper'
                              }
                              key={size + color}
                            >
                              <Form.Item
                                initialValue={attributeValue?.get(size + color)}
                                name={size + COLOR_SIZE_SEPARATOR_KEY + color}
                                rules={[
                                  {
                                    required: true,
                                    message: '',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder={'0'}
                                  size="middle"
                                  onKeyDown={(e) => {
                                    if (e.code === 'Minus') {
                                      e.preventDefault()
                                    }
                                  }}
                                  className="input"
                                  type="number"
                                  onWheel={(e: any) => e.target.blur()}
                                  min="0"
                                  defaultValue={attributeValue?.get(
                                    size + color
                                  )}
                                  onChange={({ target }) => {
                                    const temp = new Map(attributeValue)
                                    temp.set(size + color, target.value)
                                    setAttributeValue(temp)
                                  }}
                                />
                              </Form.Item>
                            </Row>
                          ))}
                        </Col>
                      ))}
                    </Row>
                  </Col>
                  <Title
                    style={{ width: '100%' }}
                    className="total-order"
                    level={5}
                  >
                    Total Order
                    Quantity:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {numberWithCommas(totalByColorSize())}
                  </Title>
                  {/* <Button htmlType="submit" type="primary" size="middle">
              Save
            </Button> */}
                </Row>
              </Form>
            )
          ))}
      </div>
    </Fade>
  )
}

export default ProductDetailForm
